<div class="py-2 px-3">
    <h1 mat-dialog-title>Delete Role</h1>
    <div class="p-2">
        <div mat-dialog-content>
            <div>Are you sure you want to delete "{{ data.role.name }}"? This cannot be undone.</div>
        </div>
    </div>
    <div class="mt-4 mb-3 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
            Cancel
        </button>
        <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
            Delete
        </button>
    </div>
</div>
